/**
 * @generated SignedSource<<9a4b8669fde8494380360aee882284b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentsCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCommentsCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitComment",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsDisplayAuthorized",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDisplayAuthorized",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesSubmissionAuthorized",
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "commentsCursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentsCount"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFromAdminUser",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalViewerFields",
          "storageKey": null
        }
      ],
      "type": "Viewer",
      "abstractKey": "__isViewer"
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresModeration",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDownAuthorized",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitVote",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesMode",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v19/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentViewerVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "singleVoteMode",
      "storageKey": null
    },
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "limitedVotesPerUser",
      "storageKey": null
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v24 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isReportable"
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Votes",
  "kind": "LinkedField",
  "name": "votes",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    (v20/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/)
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": (v17/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionCommentsPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionCommentsPanel_contribution"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContributionCommentsPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionAuthorizationsUnauthorizedMessages",
                    "kind": "LinkedField",
                    "name": "unauthorizedMessages",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": (v17/*: any*/),
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v17/*: any*/),
                                        "concreteType": "CommentConnection",
                                        "kind": "LinkedField",
                                        "name": "comments",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Comment",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v11/*: any*/),
                                                  (v12/*: any*/),
                                                  (v13/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v16/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": (v17/*: any*/),
                                                    "concreteType": "CommentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "comments",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CommentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v3/*: any*/),
                                                              (v11/*: any*/),
                                                              (v12/*: any*/),
                                                              (v13/*: any*/),
                                                              (v14/*: any*/),
                                                              (v15/*: any*/),
                                                              (v16/*: any*/),
                                                              {
                                                                "alias": null,
                                                                "args": (v17/*: any*/),
                                                                "concreteType": "CommentConnection",
                                                                "kind": "LinkedField",
                                                                "name": "comments",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "Comment",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v3/*: any*/),
                                                                          (v11/*: any*/),
                                                                          (v12/*: any*/),
                                                                          (v13/*: any*/),
                                                                          (v14/*: any*/),
                                                                          (v15/*: any*/),
                                                                          (v16/*: any*/),
                                                                          {
                                                                            "alias": null,
                                                                            "args": (v17/*: any*/),
                                                                            "concreteType": "CommentConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "comments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "CommentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Comment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                      (v3/*: any*/),
                                                                                      (v11/*: any*/),
                                                                                      (v12/*: any*/),
                                                                                      (v13/*: any*/),
                                                                                      (v14/*: any*/),
                                                                                      (v15/*: any*/),
                                                                                      (v16/*: any*/),
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": (v17/*: any*/),
                                                                                        "concreteType": "CommentConnection",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "comments",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                          {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "CommentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                              {
                                                                                                "alias": null,
                                                                                                "args": null,
                                                                                                "concreteType": "Comment",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                  (v3/*: any*/),
                                                                                                  (v11/*: any*/),
                                                                                                  (v12/*: any*/),
                                                                                                  (v13/*: any*/),
                                                                                                  (v14/*: any*/),
                                                                                                  (v15/*: any*/),
                                                                                                  (v16/*: any*/),
                                                                                                  {
                                                                                                    "alias": null,
                                                                                                    "args": (v17/*: any*/),
                                                                                                    "concreteType": "CommentConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "comments",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                      {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "concreteType": "CommentEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                          {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Comment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                              (v3/*: any*/),
                                                                                                              (v11/*: any*/),
                                                                                                              (v12/*: any*/),
                                                                                                              (v13/*: any*/),
                                                                                                              (v14/*: any*/),
                                                                                                              (v15/*: any*/),
                                                                                                              (v16/*: any*/),
                                                                                                              {
                                                                                                                "alias": null,
                                                                                                                "args": (v17/*: any*/),
                                                                                                                "concreteType": "CommentConnection",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "comments",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                  {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                      {
                                                                                                                        "alias": null,
                                                                                                                        "args": null,
                                                                                                                        "concreteType": "Comment",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "node",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                          (v3/*: any*/),
                                                                                                                          (v11/*: any*/),
                                                                                                                          (v12/*: any*/),
                                                                                                                          (v13/*: any*/),
                                                                                                                          (v14/*: any*/),
                                                                                                                          (v15/*: any*/),
                                                                                                                          (v16/*: any*/),
                                                                                                                          {
                                                                                                                            "alias": null,
                                                                                                                            "args": (v17/*: any*/),
                                                                                                                            "concreteType": "CommentConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "comments",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                              {
                                                                                                                                "alias": null,
                                                                                                                                "args": null,
                                                                                                                                "concreteType": "CommentEdge",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "edges",
                                                                                                                                "plural": true,
                                                                                                                                "selections": [
                                                                                                                                  {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "Comment",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                      (v3/*: any*/),
                                                                                                                                      (v11/*: any*/),
                                                                                                                                      (v12/*: any*/),
                                                                                                                                      (v13/*: any*/),
                                                                                                                                      (v14/*: any*/),
                                                                                                                                      (v15/*: any*/),
                                                                                                                                      (v16/*: any*/),
                                                                                                                                      (v2/*: any*/),
                                                                                                                                      (v23/*: any*/),
                                                                                                                                      (v24/*: any*/),
                                                                                                                                      (v27/*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                  },
                                                                                                                                  (v28/*: any*/)
                                                                                                                                ],
                                                                                                                                "storageKey": null
                                                                                                                              },
                                                                                                                              (v29/*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": "comments(first:2147483647)"
                                                                                                                          },
                                                                                                                          (v30/*: any*/),
                                                                                                                          (v2/*: any*/),
                                                                                                                          (v23/*: any*/),
                                                                                                                          (v24/*: any*/),
                                                                                                                          (v27/*: any*/)
                                                                                                                        ],
                                                                                                                        "storageKey": null
                                                                                                                      },
                                                                                                                      (v28/*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                  },
                                                                                                                  (v29/*: any*/)
                                                                                                                ],
                                                                                                                "storageKey": "comments(first:2147483647)"
                                                                                                              },
                                                                                                              (v30/*: any*/),
                                                                                                              (v2/*: any*/),
                                                                                                              (v23/*: any*/),
                                                                                                              (v24/*: any*/),
                                                                                                              (v27/*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                          },
                                                                                                          (v28/*: any*/)
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                      },
                                                                                                      (v29/*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": "comments(first:2147483647)"
                                                                                                  },
                                                                                                  (v30/*: any*/),
                                                                                                  (v2/*: any*/),
                                                                                                  (v23/*: any*/),
                                                                                                  (v24/*: any*/),
                                                                                                  (v27/*: any*/)
                                                                                                ],
                                                                                                "storageKey": null
                                                                                              },
                                                                                              (v28/*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                          },
                                                                                          (v29/*: any*/)
                                                                                        ],
                                                                                        "storageKey": "comments(first:2147483647)"
                                                                                      },
                                                                                      (v30/*: any*/),
                                                                                      (v2/*: any*/),
                                                                                      (v23/*: any*/),
                                                                                      (v24/*: any*/),
                                                                                      (v27/*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                  },
                                                                                  (v28/*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v29/*: any*/)
                                                                            ],
                                                                            "storageKey": "comments(first:2147483647)"
                                                                          },
                                                                          (v30/*: any*/),
                                                                          (v2/*: any*/),
                                                                          (v23/*: any*/),
                                                                          (v24/*: any*/),
                                                                          (v27/*: any*/)
                                                                        ],
                                                                        "storageKey": null
                                                                      },
                                                                      (v28/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v29/*: any*/)
                                                                ],
                                                                "storageKey": "comments(first:2147483647)"
                                                              },
                                                              (v30/*: any*/),
                                                              (v2/*: any*/),
                                                              (v23/*: any*/),
                                                              (v24/*: any*/),
                                                              (v27/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          },
                                                          (v28/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v29/*: any*/)
                                                    ],
                                                    "storageKey": "comments(first:2147483647)"
                                                  },
                                                  (v30/*: any*/),
                                                  (v2/*: any*/),
                                                  (v23/*: any*/),
                                                  (v24/*: any*/),
                                                  (v27/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v28/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v29/*: any*/)
                                        ],
                                        "storageKey": "comments(first:2147483647)"
                                      },
                                      (v30/*: any*/),
                                      (v2/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v29/*: any*/)
                            ],
                            "storageKey": "comments(first:2147483647)"
                          },
                          (v30/*: any*/),
                          (v2/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v10/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CommentsPanel_comments",
                "kind": "LinkedHandle",
                "name": "comments"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v20/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ],
                "type": "Reactable",
                "abstractKey": "__isReactable"
              }
            ],
            "type": "Contribution",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "907cb9435a0c389f1b45fe37e3965e1e",
    "id": null,
    "metadata": {},
    "name": "ContributionCommentsPanelPaginationQuery",
    "operationKind": "query",
    "text": "query ContributionCommentsPanelPaginationQuery(\n  $commentsCount: Int\n  $commentsCursor: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContributionCommentsPanel_contribution\n    id\n  }\n}\n\nfragment CommentCard_comment on Comment {\n  id\n  content\n  createdAt\n  commentsCount\n  isFromAdminUser\n  author {\n    __typename\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    requiresModeration\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    id\n  }\n  ...VoteButtons_votable\n  ...Report_reportable\n  ...ReactableMeasures_reactable\n}\n\nfragment Comment_comment on Comment {\n  id\n  title\n  ...CommentCard_comment\n  isFromAdminUser\n  comments(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...CommentCard_comment\n        comments(first: 2147483647) {\n          edges {\n            node {\n              id\n              ...CommentCard_comment\n              comments(first: 2147483647) {\n                edges {\n                  node {\n                    id\n                    ...CommentCard_comment\n                    comments(first: 2147483647) {\n                      edges {\n                        node {\n                          id\n                          ...CommentCard_comment\n                          comments(first: 2147483647) {\n                            edges {\n                              node {\n                                id\n                                ...CommentCard_comment\n                                comments(first: 2147483647) {\n                                  edges {\n                                    node {\n                                      id\n                                      ...CommentCard_comment\n                                      comments(first: 2147483647) {\n                                        edges {\n                                          node {\n                                            id\n                                            ...CommentCard_comment\n                                            comments(first: 2147483647) {\n                                              edges {\n                                                node {\n                                                  id\n                                                  ...CommentCard_comment\n                                                  comments(first: 2147483647) {\n                                                    edges {\n                                                      node {\n                                                        id\n                                                        ...CommentCard_comment\n                                                        __typename\n                                                      }\n                                                      cursor\n                                                    }\n                                                    pageInfo {\n                                                      endCursor\n                                                      hasNextPage\n                                                    }\n                                                  }\n                                                  __typename\n                                                }\n                                                cursor\n                                              }\n                                              pageInfo {\n                                                endCursor\n                                                hasNextPage\n                                              }\n                                            }\n                                            __typename\n                                          }\n                                          cursor\n                                        }\n                                        pageInfo {\n                                          endCursor\n                                          hasNextPage\n                                        }\n                                      }\n                                      __typename\n                                    }\n                                    cursor\n                                  }\n                                  pageInfo {\n                                    endCursor\n                                    hasNextPage\n                                  }\n                                }\n                                __typename\n                              }\n                              cursor\n                            }\n                            pageInfo {\n                              endCursor\n                              hasNextPage\n                            }\n                          }\n                          __typename\n                        }\n                        cursor\n                      }\n                      pageInfo {\n                        endCursor\n                        hasNextPage\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CommentsList_comments on Comment {\n  id\n  ...Comment_comment\n}\n\nfragment ContributionCommentsPanel_contribution on Contribution {\n  id\n  title\n  totalCommentsCount\n  authorizations {\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    unauthorizedMessages {\n      submitComment\n      id\n    }\n    id\n  }\n  comments(first: $commentsCount, after: $commentsCursor) {\n    edges {\n      node {\n        ...CommentsList_comments\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ReactableMeasures_reactable\n}\n\nfragment DownVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    down\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment Report_reportable on Reportable {\n  __isReportable: __typename\n  id\n}\n\nfragment UpVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    up\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment VoteButton_votable on Votable {\n  __isVotable: __typename\n  remainingVotesCount\n  limitedVotesPerUser\n}\n\nfragment VoteButtons_votable on Votable {\n  __isVotable: __typename\n  authorizations {\n    __typename\n    votesSubmissionAuthorized\n    votesDownAuthorized\n    id\n  }\n  ...UpVoteButton_votable\n  ...DownVoteButton_votable\n}\n\nfragment useVoteButtonsLabel_votable on Votable {\n  __isVotable: __typename\n  votesMode\n  currentViewerVote\n  singleVoteMode\n  ...VoteButton_votable\n}\n"
  }
};
})();

node.hash = "1d1ff1dee72e7a162a92a7a8c2c00329";

module.exports = node;
